import { Zap, MessageCircle, Phone } from "lucide-react";
import { NAV, PHONE, PHONE_TEL, waLink } from "../../data";

export const Footer = () => (
  <footer
    className="border-t border-white/10 bg-[#050e1f] py-14"
    data-testid="site-footer"
  >
    <div className="mx-auto max-w-6xl px-5">
      <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <div className="flex items-center gap-2">
            <span className="grid h-9 w-9 place-items-center rounded-lg bg-[#FFC400]">
              <Zap className="h-5 w-5 text-[#0B1F3A]" strokeWidth={2.6} />
            </span>
            <span className="font-display text-lg font-extrabold text-white">
              ELETTRIK<span className="text-[#FFC400]">PRO</span>
            </span>
          </div>
          <p className="mt-4 max-w-sm text-sm text-white/60">
            Elettricista professionale a Napoli e provincia. Pronto intervento
            elettrico, riparazioni, impianti civili e manutenzione. Interventi
            rapidi 24 ore su 24.
          </p>
        </div>

        <div>
          <p className="mb-4 font-display text-sm font-bold uppercase tracking-widest text-[#FFC400]">
            Menu
          </p>
          <ul className="space-y-2">
            {NAV.map((n) => (
              <li key={n.href}>
                <a
                  href={n.href}
                  className="text-sm text-white/60 transition-colors hover:text-white"
                >
                  {n.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="mb-4 font-display text-sm font-bold uppercase tracking-widest text-[#FFC400]">
            Contatti
          </p>
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="mb-3 flex items-center gap-2 text-sm text-white/70 transition-colors hover:text-[#FFC400]"
          >
            <MessageCircle className="h-4 w-4" /> WhatsApp: {PHONE}
          </a>
          <a
            href={`tel:${PHONE_TEL}`}
            className="flex items-center gap-2 text-sm text-white/70 transition-colors hover:text-[#FFC400]"
          >
            <Phone className="h-4 w-4" /> {PHONE}
          </a>
          <p className="mt-3 text-sm text-white/50">
            San Giorgio a Cremano (NA)
          </p>
        </div>
      </div>

      <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 sm:flex-row">
        <p className="text-xs text-white/40">
          © {new Date().getFullYear()} ELETTRIKPRO — Elettricista Napoli e
          provincia. Tutti i diritti riservati.
        </p>
        <p className="text-xs text-white/40">
          Elettricista Napoli · Pronto intervento elettrico
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
